var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-start" }, [
    _vm.useDragIcon
      ? _c("img", {
          staticClass: "icon-drag",
          attrs: { src: require("@/assets/new-form-ui/dragged.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.column.type === "single_attachment" ||
    _vm.column.type === "multiple_attachment_dynamic"
      ? _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            {
              staticClass: "input-preview attachment-preview",
              class: { "w-100": !_vm.useDragIcon }
            },
            [
              _c("img", {
                staticClass: "mr-2",
                attrs: { src: require("@/assets/new-form-ui/attachment.svg") }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Document 1")])
            ]
          )
        ])
      : _vm.column.type === "attachment"
      ? _c("div", { staticClass: "field-preview" }, [
          _vm.column.config
            ? _c(
                "div",
                _vm._l(_vm.column.config.list_options, function(config, index) {
                  return _c(
                    "div",
                    {
                      key: "config-" + config + "-" + index,
                      staticClass: "input-preview attachment-preview",
                      class: { "w-100": !_vm.useDragIcon }
                    },
                    [
                      _c("img", {
                        staticClass: "mr-2",
                        attrs: {
                          src: require("@/assets/new-form-ui/attachment.svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(config))])
                    ]
                  )
                })
              )
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "input-preview attachment-preview",
                    class: { "w-100": !_vm.useDragIcon }
                  },
                  [
                    _c("img", {
                      staticClass: "mr-2",
                      attrs: {
                        src: require("@/assets/new-form-ui/attachment.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Document 1")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "input-preview attachment-preview",
                    class: { "w-100": !_vm.useDragIcon }
                  },
                  [
                    _c("img", {
                      staticClass: "mr-2",
                      attrs: {
                        src: require("@/assets/new-form-ui/attachment.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Document 2")])
                  ]
                )
              ])
        ])
      : _vm.column.type === "toggle"
      ? _c(
          "div",
          { staticClass: "field-preview" },
          [
            _c("j-toggle", {
              staticClass: "toggle-preview",
              attrs: { disabled: true }
            })
          ],
          1
        )
      : _vm.column.type === "checkbox"
      ? _c("div", { staticClass: "field-preview" }, [
          _vm.column.config
            ? _c(
                "div",
                _vm._l(_vm.column.config.list_options_object, function(config) {
                  return _c(
                    "div",
                    {
                      key: config.value,
                      staticClass: "form-group checkbox-preview"
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "checkbox-" + config.value,
                          type: "checkbox",
                          disabled: "true"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "checkbox-" + config.value } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(config.label) + "\n        "
                          )
                        ]
                      )
                    ]
                  )
                })
              )
            : _c(
                "div",
                _vm._l(2, function(index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "form-group checkbox-preview" },
                    [
                      _c("input", {
                        attrs: {
                          id: "checkbox" + index,
                          type: "checkbox",
                          disabled: "true"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "checkbox" + index } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s("Option " + index) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                })
              )
        ])
      : _vm.column.type === "radio"
      ? _c("div", { staticClass: "field-preview" }, [
          _vm.column.config
            ? _c(
                "div",
                _vm._l(_vm.column.config.list_options_object, function(config) {
                  return _c(
                    "div",
                    {
                      key: config.value,
                      staticClass: "form-group checkbox-preview"
                    },
                    [
                      _c("input", {
                        attrs: {
                          id: "radio-" + config.value,
                          type: "radio",
                          disabled: "true"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "radio-" + config.value } }, [
                        _vm._v(
                          "\n          " + _vm._s(config.label) + "\n        "
                        )
                      ])
                    ]
                  )
                })
              )
            : _c(
                "div",
                _vm._l(2, function(index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "form-group checkbox-preview" },
                    [
                      _c("input", {
                        attrs: {
                          id: "radio" + index,
                          type: "radio",
                          disabled: "true"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "radio" + index } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s("Option " + index) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                })
              )
        ])
      : _vm.column.type === "timer"
      ? _c("div", { staticClass: "field-preview" }, [_vm._m(0)])
      : _vm.column.type === "color"
      ? _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            { staticClass: "color-preview" },
            _vm._l(10, function(index) {
              return _c("div", { key: index, class: "color color-" + index })
            })
          )
        ])
      : _vm.column.type === "location"
      ? _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            {
              staticClass: "input-preview text-preview",
              class: { "w-100": !_vm.useDragIcon }
            },
            [_c("span", [_vm._v(_vm._s("" + (_vm.column.placeholder || "")))])]
          ),
          _vm._v(" "),
          _vm.column.config && _vm.column.config.is_show_maps
            ? _c(
                "div",
                {
                  staticClass: "map-preview",
                  class: { "w-100": !_vm.useDragIcon }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/new-form-ui/map-dummy.png")
                    }
                  })
                ]
              )
            : _vm._e()
        ])
      : _vm.column.type === "custom_html"
      ? _c("div", { staticClass: "field-preview" }, [
          _vm.column.config
            ? _c("div", {
                staticClass: "html-preview",
                class: { "w-100": !_vm.useDragIcon },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.decodeHtmlEntities(_vm.column.config.html)
                  )
                }
              })
            : _c("span", [_vm._v("No configuration")])
        ])
      : _vm.column.type === "group"
      ? _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            {
              staticClass: "group-preview",
              class: { "w-100": !_vm.useDragIcon }
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm.column.config && _vm.column.config.data_field_group
                ? _c(
                    "div",
                    { staticClass: "group-preview-container" },
                    _vm._l(_vm.column.config.data_field_group, function(item) {
                      return _c("div", { key: item.field_ui_key }, [
                        _c("span", [_vm._v(_vm._s(item.name))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "input-preview text-preview",
                            class: { "w-100": !_vm.useDragIcon }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s("" + (item.placeholder || "")))
                            ])
                          ]
                        )
                      ])
                    })
                  )
                : _vm._e()
            ]
          )
        ])
      : _vm.column.type === "table_group"
      ? _c("div", { staticClass: "field-preview" }, [
          _c("div", { staticClass: "group-preview" }, [
            _c("table", { staticClass: "table table-bordered" }, [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _vm.column.config && _vm.column.config.data_field_group
                      ? _vm._l(_vm.column.config.data_field_group, function(
                          item
                        ) {
                          return _c(
                            "th",
                            {
                              key: item.field_ui_key,
                              staticClass: "text-center"
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center",
                        staticStyle: { width: "100px" }
                      },
                      [_vm._v("Action")]
                    )
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c(
                  "tr",
                  [
                    _vm.column.config && _vm.column.config.data_field_group
                      ? _vm._l(_vm.column.config.data_field_group, function(
                          item
                        ) {
                          return _c("td", { key: item.field_ui_key }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-preview text-preview",
                                class: { "w-100": !_vm.useDragIcon }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s("" + (item.placeholder || "")))
                                ])
                              ]
                            )
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td")
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      : _vm.column.type === "dynamic_field"
      ? _c("div", { staticClass: "field-preview" }, [
          _c("div", { staticClass: "group-preview" }, [
            _c(
              "div",
              { staticClass: "group-preview-container" },
              _vm._l(2, function(n) {
                return _c("div", { key: n }, [
                  _c("span", [_vm._v("Label")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-preview text-preview" }, [
                    _c("span", [
                      _vm._v(_vm._s("" + (_vm.column.placeholder || "")))
                    ])
                  ])
                ])
              })
            )
          ])
        ])
      : _vm.column.type === "code_editor"
      ? _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            {
              staticClass: "code-editor-preview",
              class: { "w-100": !_vm.useDragIcon }
            },
            [_vm._m(2)]
          )
        ])
      : _vm.column.type === "digital_signature"
      ? _c("div", { staticClass: "field-preview" }, [
          _c("div", {
            staticClass: "digital-signature-preview",
            class: { "w-100": !_vm.useDragIcon }
          })
        ])
      : _vm.column.type === "separator"
      ? _c("div", { staticClass: "field-preview" }, [
          _c("div", {
            staticClass: "separator-preview",
            class: { "w-100": !_vm.useDragIcon }
          })
        ])
      : _vm.column.type === "slider"
      ? _c("div", { staticClass: "field-preview" }, [_vm._m(3)])
      : _vm.column.type === "text_label"
      ? _c("div", { staticClass: "field-preview" }, [
          _c("div", { staticClass: "text-label-preview" }, [
            _c(
              "div",
              {
                class: {
                  "style-bold":
                    _vm.column.config &&
                    _vm.column.config.style_label.font.includes("bold"),
                  "style-italic":
                    _vm.column.config &&
                    _vm.column.config.style_label.font.includes("italic"),
                  "style-underline":
                    _vm.column.config &&
                    _vm.column.config.style_label.font.includes("underline"),
                  "style-left":
                    _vm.column.config &&
                    _vm.column.config.style_label.alignment === "left",
                  "style-center":
                    _vm.column.config &&
                    _vm.column.config.style_label.alignment === "center",
                  "style-right":
                    _vm.column.config &&
                    _vm.column.config.style_label.alignment === "right"
                }
              },
              [
                _vm.column.config &&
                _vm.column.config.style_label.heading === "h1"
                  ? _c("h1", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
                  : _vm.column.config &&
                    _vm.column.config.style_label.heading === "h2"
                  ? _c("h2", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
                  : _vm.column.config &&
                    _vm.column.config.style_label.heading === "h3"
                  ? _c("h3", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
                  : _vm.column.config &&
                    _vm.column.config.style_label.heading === "h4"
                  ? _c("h4", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
                  : _vm.column.config &&
                    _vm.column.config.style_label.heading === "h5"
                  ? _c("h5", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
                  : _vm.column.config &&
                    _vm.column.config.style_label.heading === "h6"
                  ? _c("h6", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n          This text will contain the selected column record data\n        "
                      )
                    ])
              ]
            )
          ])
        ])
      : _vm.column.type === "progress_bar"
      ? _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            { staticClass: "progress-bar-preview" },
            [
              _c(
                "b-progress",
                { staticClass: "mt-1", attrs: { max: 100 } },
                [
                  _c(
                    "b-progress-bar",
                    {
                      style:
                        "background-color: " +
                        (_vm.column.config && _vm.column.config.color
                          ? _vm.column.config.color
                          : "#2487E1") +
                        " !important",
                      attrs: { value: 40, variant: "primary" }
                    },
                    [_vm._v("\n          40%\n        ")]
                  ),
                  _vm._v(" "),
                  _c("b-progress-bar", {
                    staticStyle: { "background-color": "#D3D3D3 !important" },
                    attrs: { value: 60, variant: "secondary" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(4)
            ],
            1
          )
        ])
      : _c("div", { staticClass: "field-preview" }, [
          _c(
            "div",
            {
              staticClass: "input-preview",
              class: [
                _vm.setPreviewType(_vm.column.type),
                { "w-100": !_vm.useDragIcon }
              ]
            },
            [_c("span", [_vm._v(_vm._s("" + (_vm.column.placeholder || "")))])]
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timer-preview" }, [
      _c("div", { staticClass: "btn-timer btn-play" }, [
        _c("img", {
          attrs: { src: require("@/assets/new-form-ui/play-blue.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-timer btn-stop" }, [
        _c("img", { attrs: { src: require("@/assets/new-form-ui/stop.png") } })
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("00:00:00")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-preview-header" }, [
      _c("span", { staticClass: "index" }, [_vm._v("1")]),
      _vm._v(" "),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "code-editor-preview-container" }, [
      _c("span", [_vm._v("1")]),
      _vm._v(" "),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slider-preview" }, [
      _c("input", { attrs: { value: "1", type: "range", min: "1", max: "12" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-progress-bar" }, [
      _c("div", [_vm._v("0%")]),
      _vm._v(" "),
      _c("div", [_vm._v("50%")]),
      _vm._v(" "),
      _c("div", [_vm._v("100%")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-729572de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-729572de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/FieldPreview.vue
// module id = null
// module chunks = 